import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HmiType } from './hmi.interface';
import { getApplication, getApplicationDependency, getToolDependency, selectParentApp } from './hmiSlice';
import { HmiDaas } from './HmiDaas';
import { HmiBaas } from './HmiBaas';
import { HmiHATApp } from './HmiHATApp';
import { selectLanguage } from '../language/languageSlice';
import './Hmi.scss';

type Props = {
  path?: string;
  applicationId: string;
  hmiType: HmiType;
};

export const Hmi: React.FC<Props> = (props) => {
  const parentApp = useSelector(selectParentApp);
  const language = useSelector(selectLanguage);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.applicationId) {
      dispatch(getApplication(props.applicationId, language));
    }
    // eslint-disable-next-line
  }, [props.applicationId]);

  useEffect(() => {
    if (parentApp && parentApp.dependencies) {
      if (parentApp.dependencies.plugs.length > 0) {
        parentApp.dependencies.plugs.forEach((appId) => {
          dispatch(getApplicationDependency(appId));
        });
      }

      if (parentApp.dependencies.tools.length > 0) {
        dispatch(getToolDependency(parentApp.dependencies.tools[0]));
      }
    }
    // eslint-disable-next-line
  }, [parentApp]);

  const isHatApp = ['hatapp', 'hatappstaging'].indexOf(props.applicationId) !== -1;

  return (
    <div className={'hmi-page'}>
      <div className={'hmi-page-wrapper'}>
        {isHatApp ? (
          <HmiHATApp hmiType={props.hmiType} />
        ) : (
          <>
            {parentApp && props.hmiType === HmiType.daas && <HmiDaas />}
            {parentApp && props.hmiType === HmiType.baas && <HmiBaas />}
          </>
        )}
      </div>
    </div>
  );
};
